export default __webpack_public_path__ + "146adc994810c10faf015a71a8d6d24d.svg";